import React, { useEffect } from 'react';
import { Row, Col, Form, Button } from 'react-bootstrap';
import { useAmbientAudio } from '../../hooks/useAmbientAudio';
import { useLang } from "../../contexts/LanguageContext";
import fetchWithAuth from '../../api/fetchWithAuth';
import apiUrls from '../../api/apiUrls';

export const AmbientSelector = ({ preferences, bookLanguage, onChange }) => {
  const { t } = useLang();
  const { 
    currentTrackId, 
    volume, 
    isPlaying, 
    tracks, 
    selectTrack, 
    togglePlay, 
    updateVolume 
  } = useAmbientAudio(preferences);

  // Notificar al padre cuando cambian los valores locales para que se sincronicen con la API
  useEffect(() => {
    if (preferences && onChange) {
      if (currentTrackId !== preferences.ambientTrackId) {
        onChange('ambientTrackId', currentTrackId);
      }
    }
  }, [currentTrackId]);

  useEffect(() => {
    if (preferences && onChange) {
      if (volume !== preferences.ambientVolume) {
        onChange('ambientVolume', volume);
      }
    }
  }, [volume]);

  return (
    <div className="ambient-selector p-3">
      <h6 className="mb-3">{t("AMBIENT_TITLE")}</h6>
      
      <Row className="g-2 mb-3">
        <Col xs={12}>
          <div className="d-flex flex-wrap gap-2">
            <Button 
              variant={currentTrackId === null ? "primary" : "outline-primary"}
              size="sm"
              onClick={() => selectTrack(null)}
              className="rounded-pill"
            >
              {t("AMBIENT_OFF")}
            </Button>
            {tracks.map(track => (
              <Button 
                key={track.id}
                variant={currentTrackId === track.id ? "primary" : "outline-primary"}
                size="sm"
                onClick={() => selectTrack(track.id)}
                className="rounded-pill d-flex align-items-center gap-1"
              >
                <span>{t(`AMBIENT_${track.id.toUpperCase()}`)}</span>
              </Button>
            ))}
          </div>
        </Col>
      </Row>

      {currentTrackId && (
        <Row className="align-items-center">
          <Col xs="auto">
            <Button 
              variant="link" 
              className="p-0 text-primary" 
              onClick={togglePlay}
            >
              <i className={`bi bi-${isPlaying ? 'pause-fill' : 'play-fill'} fs-4`}></i>
            </Button>
          </Col>
          <Col>
            <Form.Range 
              value={volume * 100} 
              onChange={(e) => updateVolume(parseFloat(e.target.value) / 100)}
              min={0}
              max={100}
            />
          </Col>
          <Col xs="auto" className="text-muted small" style={{ minWidth: '35px' }}>
            {Math.round(volume * 100)}%
          </Col>
        </Row>
      )}
    </div>
  );
};
